
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LoadingButton } from '@mui/lab';

export default function ConfirmDialog({doShowConfirm, handleClose, confirmTitle, confirmText, positiveButtonText, negativeButtonText, buttonsDisabled}) {
    return (
      <Dialog
        open={doShowConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{confirmTitle}</DialogTitle>
        <DialogContent>
          {confirmText}
        </DialogContent>

        <DialogActions>
          <LoadingButton
            onClick={() => handleClose(true)}
            color="primary"
            variant="outlined"
            disabled={buttonsDisabled}
            loadingPosition="center"
            loading={buttonsDisabled}
          >
            {positiveButtonText ?? "Yes"}
          </LoadingButton>
          <Button onClick={() => handleClose(false)} color="primary" variant="outlined" disabled={buttonsDisabled}>
            {negativeButtonText ?? "No"}
          </Button>
        </DialogActions>
      </Dialog>
    );
}